import { render, staticRenderFns } from "./StateProfilesWebGranteesList.vue?vue&type=template&id=2ebb4e0e&scoped=true&"
import script from "./StateProfilesWebGranteesList.vue?vue&type=script&lang=js&"
export * from "./StateProfilesWebGranteesList.vue?vue&type=script&lang=js&"
import style0 from "./StateProfilesWebGranteesList.vue?vue&type=style&index=0&id=2ebb4e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb4e0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
